import { useLocation, useNavigate } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

export default function PrivateTxnSuccess() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (state === null) {
      navigate("/private_transaction_dashboard/create_private_transaction", {
        replace: true,
      });
    }
  }, []);

  return (
    <StatusContainer
      title={
        "File uploaded successfully, you will be notified by email once the file verification process is complete."
      }
      buttonRows={[
        [
          {
            btnText: "Upload new file",
            enabledBgColor: "var(--text-primary)",
            enabledTextColor: "var(--positive-bg)",
            icon: "https://q2pay.in/new_assets/common/view_all/upload.svg",
            handleFunction: (e) =>
              navigate(
                "/private_transaction_dashboard/create_private_transaction",
              ),
            iconToBeAlign: "left",
            fullWidthRequired: true,
            imgColor: "var(--positive-bg)",
          },
          {
            btnText: "View details",
            enabledBgColor: "var(--text-primary)",
            enabledTextColor: "var(--positive-bg)",
            icon: "https://q2pay.in/new_assets/common/create_flow/detail_page_linear.svg",
            handleFunction: (e) =>
              navigate(
                "/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/" +
                  state?.txn,
              ),
            iconToBeAlign: "left",
            fullWidthRequired: true,
            imgColor: "var(--positive-bg)",
          },
        ],
        [
          {
            btnText: "Go to dashboard",
            enabledBgColor: "var(--bg-positive-bg)",
            enabledTextColor: "var(--text-primary)",
            icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
            handleFunction: (e) => navigate("/private_transaction_dashboard"),
            iconToBeAlign: "left",
            fullWidthRequired: true,
            outLineColor: "var(--text-primary)",
          },
        ],
      ]}
      status="success"
    >
      <TabsWeapperSection title={"File details"}>
        <>
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: state?.file?.name ?? "No file",
                leftSubTitle: "File name",
              },
            ]}
          />

          <InfoCard
            bgColor="var(--positive-card)"
            onClick={(e) =>
              navigate(
                `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${state?.ownerDetail?.ownerId ?? ""}`,
              )
            }
            hoverable="white"
            rows={[
              {
                leftTitle: formatAccountNumber(
                  state?.ownerDetail?.ownerBankAccountNo ?? "0000000000",
                ),
                leftSubTitle: "Source account",
                ifsc: state?.ownerDetail?.ownerBankIFSC ?? "",
                rightIcon: true,
              },
            ]}
          />

          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: state?.category?.label ?? "",
                leftSubTitle: "Transaction category",
                icon: state?.category?.icon ?? "",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.labels?.length > 0
                    ? state.labels.join(", ")
                    : "No labels assigned",
                leftSubTitle: "Labels",
              },
            ]}
          />
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
}
